// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__2JIJi","vLegacy":"SelectSecondary_vLegacy__2De9U","error":"SelectSecondary_error__1-YN-","disabled":"SelectSecondary_disabled__1F3KC"};